module.exports = __webpack_public_path__ + "img/logout.8db9343b.svg";